import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import {
    getHasAllStyleguideSectionsOpen,
    getStyleguideSectionById,
} from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideSelectors";

export const useIsStyleguideSectionOpen = (id: string) => {
    return useAppSelector(state => getStyleguideSectionById(state, id))?.isOpen;
};

export const useHasAllStyleguideSectionsOpen = () => {
    return useAppSelector(state => getHasAllStyleguideSectionsOpen(state));
};
